import axios from 'axios'
import * as Types from '../types'

export default
{
	state:
	{
	},

	getters:
	{
	},

	mutations:
	{
	},

	actions:
	{
		[Types.TWO_FACTOR_DISABLE]({ dispatch })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/auth/two-factor/disable')
						.then
						(
							async response =>
							{
								await dispatch(Types.SET_AUTH_USER)

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.TWO_FACTOR_ENABLE]({ dispatch })
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/auth/two-factor/enable')
						.then
						(
							async response =>
							{
								await dispatch(Types.SET_AUTH_USER)

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},

		[Types.TWO_FACTOR_VERIFY]({ dispatch }, data)
		{
			return new Promise
			(
				(resolve, reject) =>
				{
					axios.post('/api/auth/two-factor/verify', data)
						.then
						(
							async response =>
							{
								await dispatch(Types.LOGIN_SUCCESS, response.data)

								resolve(response)
							}
						)
						.catch(reject)
				}
			)
		},
	},
}